import { FC } from "react";
import { IEsimInstallationDiagnostics } from "../../../interfaces/esim/EsimDiagnostics.types";
import { formatDataSize, formatDateTimeSq } from "../../../utils/esim/format";

const YesNo: FC<{ value: boolean }> = ({ value }) => (
  <span className={`text-sm font-medium ${value ? "text-green" : "text-gray-500"}`}>
    {value ? "Po" : "Jo"}
  </span>
);

const ConnectivityCard: FC<{ data: IEsimInstallationDiagnostics }> = ({ data }) => (
  <div className="bg-white p-4 rounded-lg shadow-sm">
    <h3 className="text-sm font-semibold text-gray-700 mb-2">Lidhshmëria</h3>
    <div className="flex justify-between gap-4 py-1 border-b">
      <span className="text-sm text-gray-500">Regjistruar në OCS</span>
      <span className="text-sm font-medium text-gray-800 text-right">
        {formatDateTimeSq(data.activationDateUtc)}
      </span>
    </div>
    <div className="flex justify-between gap-4 py-1 border-b">
      <span className="text-sm text-gray-500">A është lidhur me rrjetin</span>
      <YesNo value={data.hasEverConnected} />
    </div>
    <div className="flex justify-between gap-4 py-1 border-b">
      <span className="text-sm text-gray-500">Të dhëna të përdorura</span>
      <span className="text-sm font-medium text-gray-800 text-right">
        {formatDataSize(data.usedDataBytes)}
      </span>
    </div>
    <div className="flex justify-between gap-4 py-1">
      <span className="text-sm text-gray-500">Ka paketë aktive</span>
      <YesNo value={data.hasActivePackage} />
    </div>
  </div>
);

export default ConnectivityCard;
